import type { ReactNode } from "react";

import { Trash2 } from "lucide-react";

import { ProgressSpinner } from "@/features/my-files/components/upload-files-modal/components/progress-spinner";

import { FileTypeIcon } from "./FileTypeIcon";

interface FileRowProps {
  canCancel: boolean;
  canRemove: boolean;
  combobox: ReactNode;
  extension: string;
  mime?: string;
  onCancelUpload: () => void;
  onRemove: () => void;
  progress?: number;
  removeDisabled?: boolean;
  showProgress: boolean;
  statusLabel: ReactNode;
}

export function FileRow({
  canCancel,
  canRemove,
  combobox,
  extension,
  mime,
  onCancelUpload,
  onRemove,
  progress,
  removeDisabled = false,
  showProgress,
  statusLabel,
}: FileRowProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-start gap-2">
        <div className="mt-6 shrink-0">
          <FileTypeIcon extension={extension} mime={mime} />
        </div>
        {combobox}
        <div className="mt-6 flex w-[88px] shrink-0 items-center justify-end gap-1">
          {showProgress && progress !== undefined ? (
            <ProgressSpinner progress={progress} size={28} />
          ) : null}

          {canCancel ? (
            <button
              className="rounded-md px-2 py-1.5 text-xs font-medium text-text-brand-primary transition-colors hover:bg-bg-secondary"
              onClick={onCancelUpload}
              type="button"
            >
              Cancel
            </button>
          ) : null}

          {canRemove ? (
            <button
              aria-label="Remove file"
              className="rounded-md p-1.5 text-text-error-primary transition-colors hover:bg-bg-error-secondary"
              disabled={removeDisabled}
              onClick={onRemove}
              type="button"
            >
              <Trash2 size={16} />
            </button>
          ) : null}
        </div>
      </div>
      {statusLabel}
    </div>
  );
}
